// Categorías de las ofertas (campo `category` del documento en /offers). Las
// usan el feed (filtro en home.js), publicar y editar oferta. Los ids se
// guardan en Firestore: no cambiarlos; para renombrar, cambiar solo `label`.
export const OFFER_CATEGORIES = [
  { id: "electro", label: "Electrodomésticos y tecnología" },
  { id: "moda", label: "Moda y calzado" },
  { id: "belleza", label: "Belleza y salud" },
  { id: "hogar", label: "Hogar, jardín y herramientas" },
  { id: "deportes", label: "Deportes y aire libre" },
  { id: "comida", label: "Comida y bebidas" },
  { id: "viajes", label: "Viajes y turismo" },
  { id: "ninos", label: "Bebés, niños y juguetes" },
  { id: "mascotas", label: "Mascotas" },
  { id: "entretenimiento", label: "Juegos, libros y entretenimiento" },
  { id: "servicios", label: "Servicios, cursos y software" },
  { id: "otros", label: "Otros" },
];

export const getOfferCategoryLabel = (id) =>
  OFFER_CATEGORIES.find((c) => c.id === id)?.label || "";
